import { AfterViewInit, Directive, ElementRef, Input, OnChanges, Renderer2, inject } from '@angular/core';

const DISABLED = 'disabled';
const APP_DISABLED = 'app-disabled';
const TAB_INDEX = 'tabindex';
const TAG_ANCHOR = 'a';

@Directive({
    selector: '[appDisable]',
    standalone: false
})
export class DisableDirective implements OnChanges, AfterViewInit {

    el = inject(ElementRef);
    renderer = inject(Renderer2);

    @Input()
    appDisable = true;

    ngOnChanges(): void {
        this.disableElement(this.el.nativeElement);
    }

    ngAfterViewInit(): void {
        this.disableElement(this.el.nativeElement);
    }

    private disableElement(element: any): void {
        if (this.appDisable) {
            if (!element.hasAttribute(DISABLED)) {
                this.renderer.setAttribute(element, APP_DISABLED, '');
                this.renderer.setAttribute(element, DISABLED, 'true');

                // disabling anchor tab keyboard event
                if (element.tagName.toLowerCase() === TAG_ANCHOR) {
                    this.renderer.setAttribute(element, TAB_INDEX, '-1');
                }
            }
        } else if (element.hasAttribute(APP_DISABLED)) {
            if (element.getAttribute('disabled') !== '') {
                element.removeAttribute(DISABLED);
            }
            element.removeAttribute(APP_DISABLED);
            if (element.tagName.toLowerCase() === TAG_ANCHOR) {
                element.removeAttribute(TAB_INDEX);
            }
        }
        if (element.children) {
            for (let ele of element.children) {
                this.disableElement(ele);
            }
        }
    }
}
